<template>
  <div class="divBottom">
    <div class="divContainer">
      <div class="divTop">
        <div class="divImg" @click="bottomClick">
          <img src="./../../assets/logoFoot.png" alt />
        </div>
        <div class="divDesc">
          传智研究院是传智教育旗下科研部门，汇集了众多互联网专家，技术人才，为企业技术发展，公司课程研发，学员成长提供强大的驱动力。
        </div>
        <div class="line"></div>
        <div class="divLink">
          <div class="divTitle">友情链接</div>
          <div class="divLinkDetails">
            <div
              v-for="(item, index) in linkData"
              :key="index"
              class="divItem"
              @click="jumpPage(item.url, item.desc, index)"
            >
              <span>{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="divDown">
        <!-- <div v-for="(item, index) in msg.split(',')" :key="index">
          {{ item }}
        </div> -->
        <span
          >江苏传智播客教育科技股份有限公司 版权所有Copyright 2006-2020 All
          Rights Reserved</span
        >
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >苏ICP备16007882号-11营业执照增值电信业务经营许可证</a
        ><a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=32132202001156"
          rel="noreferrer"
          target="_blank"
          ><img src="@/assets/icon02.png" />苏公网安备32132202001156号</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    msg: {
      type: String,
      default:
        '江苏传智播客教育科技股份有限公司,版权所有Copyright 2006-2020 All Rights Reserved,苏ICP备16007882号-11号营业执照增值电信业务经营许可证',
    },
    linkData: {
      type: Array,
      default: () => [
        {
          desc: '传智教育',
          url: 'http://www.itcast.cn',
        },
        {
          desc: '黑马程序员',
          url: 'http://www.itheima.com/',
        },
        {
          desc: '博学谷',
          url: 'https://www.boxuegu.com/',
        },
        { desc: '大同数据科技职业学院', url: 'https://www.czxy.com/?cz-pc-dh' },
        {
          desc: '酷丁鱼',
          url: 'https://www.kudingyu.com/',
        },

        {
          desc: '传智汇',
          url: 'http://www.itczh.com/',
        },
        {
          desc: '院校邦',
          url: 'http://www.ityxb.com/',
        },
        {
          desc: '宿迁传智互联网中等职业技术学校',
          url: 'https://www.zhongzhi.com',
        },
      ],
    },
  },
  methods: {
    bottomClick() {
      this.$trackEvent('底部logo', '点击');
    },
    jumpPage(url, name, index) {
      const list = [
        '友情链接-传智教育',
        '友情链接-传智汇',
        '友情链接-黑马程序员',
        '友情链接-传智专修学院',
        '友情链接-博学谷',
        '友情链接-酷丁鱼',
        '友情链接-院校邦',
      ];
      this.$trackEvent(list[index], '点击跳转', name);
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.divBottom {
  height: 173px;
  background: #f2f4f6;
  .divContainer {
    width: 1200px;
    margin: 0 auto;
    .divTop {
      display: flex;
      align-items: center;
      height: 80px;
      padding: 10px 0;
      .divImg {
        margin-right: 33px;
        img {
          height: 47px;
          width: 71px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .divDesc {
        width: 320px;
        height: 56px;
        font-size: 12px;
        text-align: left;
        color: #616a72;
        line-height: 17px;
        padding-right: 33px;
        padding-top: 8px;
      }
      .line {
        border-right: 1px solid #dee1e5;
        height: 48px;
        margin-top: 5px;
      }
      .divLink {
        padding-left: 41px;
        // height: 56px;

        .divTitle {
          height: 17px;
          font-size: 12px;
          text-align: right;
          color: #616a72;
          line-height: 17px;
          text-align: left;
          margin-bottom: 12px;
          font-weight: 700;
        }
        .divLinkDetails {
          display: flex;
          flex-wrap: wrap;
          font-size: 12px;
          text-align: left;
          color: #616a72;
          line-height: 17px;
          margin-left: -8px;
          .divItem {
            color: #616a72;
            cursor: pointer;
            white-space: nowrap;
            span {
              border-right: 1px solid #dee1e5;
              padding-right: 10px;
              padding-left: 10px;
            }
            &:first-child,
            &:last-child {
              padding-left: 0px;
            }
            &:last-child {
              span {
                border: 0 none;
                padding-right: 0;
              }
            }
          }
        }
      }
    }
    .divDown {
      display: flex;
      align-items: center;
      height: 70px;
      border-top: 1px solid #dee1e5;
      display: flex;
      align-items: center;
      span {
        padding: 0 5px;
        
      }
      a {
          text-decoration: none;
          display: flex;
          align-items: center;
          margin: 0 5px;
          img {
            width: 20px;
            margin-right: 5px;
          }
        }
      div {
        height: 17px;
        font-size: 12px;
        text-align: right;
        color: #616a72;
        line-height: 17px;
        margin-right: 20px;
        &:last-child {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>
